module.exports = __webpack_public_path__ + "img/product-placeholder-74.2e43dca.png";